module.exports = __webpack_public_path__ + "static/img/introduceCType3.1d4a59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceCType3.png
// module id = Oia2
// module chunks = 0